export const isLearningPath = () => {
  return window.location.href.includes('learning-path')
}
